<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Sms Sent Messages</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button routerLink="/user/''">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="instructions">
        Account Number: {{accountProfile.accountNumber}}<br />
        Dealership: {{dealership.dealershipName}}
    </ion-list-header>

    <ion-list>
        @for (sms of smsSentMessages; track $index) {
  <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Sent To Customer: 
                    {{sms.sentToCustomerDate| myTimestamp : 'EEE, MMM d yyyy, hh:mm:ss:SSS a'}} ({{sms.toNumber}})</span><br />
                <span class="line2">Sent To Twilio: 
                    {{sms.sentToTwilioDate| myTimestamp : 'EEE, MMM d yyyy, hh:mm:ss:SSS a'}}</span><br />
                <span class="line2">Sms Type: {{sms.smsType}}</span><br />
                <span class="line2 truncate">Message: {{sms.message}}</span>
                <!-- <span class="line1">From Number: {{sms.fromNumber}}</span><br /> -->
                <!-- <span class="line1">Session Id: {{sms.sessionId}}</span><br /> -->
                <!-- <span class="line1">To Number: {{sms.toNumber}}</span><br /> -->
                <!-- <span class="line1">Segments: {{sms.numSegments}}</span><br /> -->
                <!-- <span class="line1">uid: {{sms.uid}}</span><br /> -->
            </ion-label>
        </ion-item>
}
    </ion-list>
</ion-content>
